import type { ReactElement } from 'react';
import type { PortalLocale } from '@worldcoo/monolith/portals';
import { CatalanFlag, FranceFlag, ItalyFlag, SpainFlag, UkFlag } from './icons';
import { wwwLocales, type WwwLocale } from './locales';

/** Mapped from `locales.ts`, so a new locale reaches the switcher and the `Record` demands its label. */
const LABELS: Record<WwwLocale, { short: string; label: string }> = {
	es: { short: 'ES', label: 'Español' },
	en: { short: 'EN', label: 'English' },
	ca: { short: 'CA', label: 'Català' },
	fr: { short: 'FR', label: 'Français' },
	it: { short: 'IT', label: 'Italiano' },
};

type Language = { code: WwwLocale; short: string; label: string };

// `.map` widens the non-empty tuple to an array; the header's fallback leans on a first entry.
export const LANGUAGES = wwwLocales.map((code) => ({ code, ...LABELS[code] })) as [Language, ...Language[]];

const FLAGS: Partial<Record<PortalLocale, (props: { className?: string }) => ReactElement>> = {
	es: SpainFlag,
	en: UkFlag,
	ca: CatalanFlag,
	it: ItalyFlag,
	fr: FranceFlag,
};

export function LanguageFlag({ code, className }: { code: PortalLocale; className?: string }) {
	const Flag = FLAGS[code] ?? SpainFlag;
	return <Flag className={className} />;
}
